@if (timeline.isOpen()) {
  <div
    class="timeline-overlay"
    (click)="timeline.close()"
    (keydown)="onKeydown($event)"
    tabindex="0"
  >
    <div class="timeline-modal" (click)="$event.stopPropagation()">
      <button
        type="button"
        class="timeline-modal__close"
        (click)="timeline.close()"
        aria-label="Chiudi"
      >
        ✕
      </button>

      <header class="timeline-modal__header">
        <div class="timeline-modal__eyebrow">Roadmap del progetto</div>
        <h2 class="timeline-modal__title">L'evoluzione di Diakonix</h2>
        <p class="timeline-modal__subtitle">
          Dalla prima release del 2022 a oggi, tutti i momenti che
          hanno plasmato il prodotto.
        </p>
      </header>

      <div class="timeline-modal__scroll">
        <ol class="timeline">
          @for (entry of entries; track entry.version) {
            <li class="timeline__item" [attr.data-type]="entry.type">
              <div class="timeline__node" aria-hidden="true"></div>
              <div class="timeline__content">
                <div class="timeline__meta">
                  <span class="timeline__date">{{ formatDate(entry.date) }}</span>
                  <span class="timeline__version">{{ entry.version }}</span>
                  @if (entry.type === 'milestone') {
                    <span class="timeline__badge timeline__badge--milestone">
                      Milestone
                    </span>
                  }
                  @if (entry.type === 'genesis') {
                    <span class="timeline__badge timeline__badge--genesis">
                      Genesi
                    </span>
                  }
                  @if (entry.type === 'current') {
                    <span class="timeline__badge timeline__badge--current">
                      Versione attuale
                    </span>
                  }
                </div>
                <h3 class="timeline__title">{{ entry.title }}</h3>
                <p class="timeline__description">{{ entry.description }}</p>
                @if (entry.highlights && entry.highlights.length > 0) {
                  <ul class="timeline__highlights">
                    @for (highlight of entry.highlights; track highlight) {
                      <li class="timeline__highlight">{{ highlight }}</li>
                    }
                  </ul>
                }
              </div>
            </li>
          }
        </ol>
      </div>
    </div>
  </div>
}
